import {Component, EventEmitter, Injector, Input, OnInit, Output} from '@angular/core';
import {DefaultService} from '../../../../gen/swagger-api/api/default.service';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {ErrorHandlingService} from '../../../shared/services/error-handling-service';
import {ACLINFO, CARDGROUPINFO, POOLINFO, USERINFO} from '../../../../gen/swagger-api';
import {AlertService} from '../../../shared/services/alert.service';
import {ModalBaseComponent} from '../modal-base-component';
import {FormBuilder, FormGroup} from '@angular/forms';
import {USERACCESSCONTROL} from '../../../shared/model/USERACCESSCONTROL';

@Component({
  selector: 'app-add-new-user-permission',
  templateUrl: './add-new-user-permission.component.html',
  styleUrls: ['./add-new-user-permission.component.css']
})
export class AddNewUserPermissionComponent extends ModalBaseComponent implements OnInit {

  public permission: USERACCESSCONTROL = {} as USERACCESSCONTROL;
  @Output() action = new EventEmitter();
  @Input() userID: string;
  newPermissionFormGroup: FormGroup;
  errorObjectId = false;
  errorObjectType = false;
  accessControlOverUserId = '';
  objectIds = [];
  private bsModalRef: BsModalRef;

  constructor(private inject: Injector,
              private defaultService: DefaultService,
              private modalService: BsModalService,
              private alertService: AlertService,
              private errorHandlingService: ErrorHandlingService,
              private formBuilder: FormBuilder,
              private _bsModalRef: BsModalRef) {
    super(inject);
  }

  public closeModal(): void {
    this._bsModalRef.hide();
  }

  ngOnInit() {
    this.newPermissionFormGroup = this.formBuilder.group({
      objectId: [''],
      objectType: [''],
      delete: [false],
      read: [false],
      update: [false],
      use: [false],
      withGrantOption: [false]
    });

    this.onChanges();
  }


  onChanges() {
    this.newPermissionFormGroup.controls['objectType'].valueChanges.subscribe(value => {
      switch (value.toString()) {
        case '0': // POOL
          this.defaultService.poolsGet().subscribe(response => {
            this.objectIds = [];
            response = response.sort((n1, n2) => {
              if (n1.poolId > n2.poolId) {
                return 1;
              }

              if (n1.poolId < n2.poolId) {
                return -1;
              }

              return 0;
            });

            this.objectIds.push('* - Wildcard permission');

            response.forEach((pool: POOLINFO) => {
              this.objectIds.push(pool.poolId.toString() + ' - ' + pool.poolName);
            });
          });
          break;

        case '1': // POOL CREATION
          this.objectIds = [];
          this.objectIds.push('action - Operations permission');
          break;

        case '2': // CARD_GROUP
          this.defaultService.cardGroupsGet().subscribe(response => {
            this.objectIds = [];
            response = response.sort((n1, n2) => {
              if (+n1.cardGroupId > +n2.cardGroupId) {
                return 1;
              }

              if (+n1.cardGroupId < +n2.cardGroupId) {
                return -1;
              }

              return 0;
            });

            this.objectIds.push('* - Wildcard permission');

            response.forEach((cardGroup: CARDGROUPINFO) => {
              this.objectIds.push(cardGroup.cardGroupId.toString() + ' - ' + cardGroup.groupName);

            });
          });
          break;

        case '3': // CARD GROUP CREATION
          this.objectIds = [];
          this.objectIds.push('action - Operations permission');
          break;

        case '4': // USER_MANAGEMENT
          this.defaultService.usersGet().subscribe(response => {
            this.objectIds = [];
            response.forEach((user: USERINFO) => {
              let userName = '';
              if (user.firstName || user.lastName) {
                userName = ' - ' + user.firstName + ' ' + user.lastName;
              }
              this.objectIds.push(user.userId.toString() + userName);
              this.objectIds = this.objectIds.sort((n1, n2) => {
                if (n1 > n2) {
                  return 1;
                }
                if (n1 < n2) {
                  return -1;
                }
                return 0;
              });
            });
            this.objectIds.splice(0, 0, '* - Wildcard permission');
          });
          break;

        case '5': // USER CREATION
          this.objectIds = [];
          this.objectIds.push('action - Operations permission');
          break;

        case '6': // IMPORT
            this.objectIds = [];
            this.objectIds.push('action - Operations permission');
          break;

        case '7': // PROFILE
          this.objectIds = [];
          this.objectIds.push('action - Operations permission');
          break;
      }
    });
    this.newPermissionFormGroup.controls['objectId'].valueChanges.subscribe(value => {
      this.accessControlOverUserId = this.objectIds[+value].split('-')[0].toString().trim();
    });
  }

  public addUserPermission(): void {

    this.permission = this.newPermissionFormGroup.value;
    const passed = this.validation();
    if (!passed) {
      return;
    }
    switch (this.permission.objectType.toString()) {
      case '0':
        this.permission.objectType = ACLINFO.ObjectTypeEnum.POOL;
        this.permission.objectId = this.accessControlOverUserId;
        break;
      case '1':
        this.permission.objectType = ACLINFO.ObjectTypeEnum.POOLCREATION;
        this.permission.objectId = this.accessControlOverUserId;
        break;
      case '2':
        this.permission.objectType = ACLINFO.ObjectTypeEnum.CARDGROUP;
        this.permission.objectId = this.accessControlOverUserId;
        break;
      case '3':
        this.permission.objectType = ACLINFO.ObjectTypeEnum.CARDGROUPCREATION;
        this.permission.objectId = this.accessControlOverUserId;
        break;
      case '4':
        this.permission.objectType = ACLINFO.ObjectTypeEnum.USERMANAGEMENT;
        this.permission.objectId = this.accessControlOverUserId;
        break;
      case '5':
        this.permission.objectType = ACLINFO.ObjectTypeEnum.USERCREATION;
        this.permission.objectId = this.accessControlOverUserId;
        break;
      case '6':
        this.permission.objectType = ACLINFO.ObjectTypeEnum.IMPORT;
        this.permission.objectId = this.accessControlOverUserId;
        break;
      case '7':
        this.permission.objectType = ACLINFO.ObjectTypeEnum.PROFILE;
        this.permission.objectId = this.accessControlOverUserId;
        break;
    }

    if (this.permission.objectId !== undefined) {
      this.defaultService.usersUserIdPermissionsPut(this.userID, this.permission).subscribe((item) => {
          this.alertService.successModal('New permission added');
          this.action.emit(true);
        },
        (error) => {
          if (error) {
            this.errorHandlingService.errorHandling(error);
          }
        });
      this.closeModal();
    }
  }

  public validation(): boolean {

    if (this.permission.objectId === 'action' ||
      this.permission.objectId === 'role' ||
      this.permission.objectId === '*' ||
      this.checkIfStringIsNumber(this.permission.objectId)) {
      this.errorObjectId = false;
    } else {
      this.errorObjectId = true;
      return false;
    }

    if (this.permission.objectType.toString() === '') {
      this.errorObjectType = true;
      return false;
    } else {
      this.errorObjectType = false;
    }

    return true;
  }

  checkIfStringIsNumber(input: string): boolean {
    const num = +input;
    return !isNaN(num);
  }
}



// WEBPACK FOOTER //
// ./src/app/achelos-iot/modals/add-new-user-permission/add-new-user-permission.component.ts